module.exports = __webpack_public_path__ + "img/gift-workmate-title.8abdb985.png";